import { render, staticRenderFns } from "./recyclingProductForm.vue?vue&type=template&id=706c0fcc&scoped=true"
import script from "./recyclingProductForm.vue?vue&type=script&lang=js"
export * from "./recyclingProductForm.vue?vue&type=script&lang=js"
import style0 from "./recyclingProductForm.vue?vue&type=style&index=0&id=706c0fcc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706c0fcc",
  null
  
)

export default component.exports